/**
 * Please prefix constants with `"SOURCE_"`. They are exported via the global constants file at the root
 * of the package.
 */
export const SOURCE_FLAG_NAMES = {
  SOURCE_EARLY_ACCESS: 'ff-pion-987-source-early-access',
  SOURCE_LLM_PROXY_DECISIONS: 'ff-sour-4087-llm-proxy-decisions',
};
